import React from 'react';

import wizardStep from 'images/Wizard/wizardStep.svg';
import wizardStepCompleted from 'images/Wizard/wizardStepCompleted.svg';
import wizardStepCurrent from 'images/Wizard/wizardStepCurrent.svg';
import { observer } from 'mobx-react-lite';
import { StyledElement } from './styles/WizardStepStyles';
import WizardSteps from './WizardSteps';

export interface IWizardStepProps {
  step: WizardSteps;
  currentStep: WizardSteps;
}

export const WizardStep: React.FC<IWizardStepProps> = observer(({ step, currentStep }) => {
  let image = '';
  let text = '';

  switch (step) {
    case WizardSteps.Introduction:
      text = 'Introduction';
      break;
    case WizardSteps.CleanHomeplate:
      text = 'Clean homeplate';
      break;
    case WizardSteps.CorrectPitching:
      text = 'Correct pitching';
      break;
    case WizardSteps.DataCapture:
      text = 'Data capture';
      break;
  }

  switch (true) {
    case currentStep < step:
      image = wizardStep;
      break;
    case currentStep === step:
      image = wizardStepCurrent;
      break;
    case currentStep > step:
      image = wizardStepCompleted;
      break;
  }

  return (
    <StyledElement title={text} step={step} currentStep={currentStep}>
      <img src={image} alt='image content' />
    </StyledElement>
  );
});
